import { Component } from '@angular/core';

@Component({
    selector: 'app-activity-review',
    templateUrl: './activity-review.component.html',
    styleUrls: ['./activity-review.component.scss'],
    standalone: false
})
export class ActivityReviewComponent {}
